import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VCard,[_c(VCardText,[_c('h1',[_vm._v("TEST")]),_c(VRow,[_c(VCol,[_c('app-datetime-picker',{attrs:{"disableTime":_vm.timeDisabled},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_c(VSwitch,{model:{value:(_vm.timeDisabled),callback:function ($$v) {_vm.timeDisabled=$$v},expression:"timeDisabled"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }